import axiosInstance from "../services/axiosInstance";

export const fetchLocations = async ({
  companyId,
  page = 1,
  perPage = 10,
  search = "",
}) => {
  try {
    const response = await axiosInstance.get("console/location/get", {
      params: {
        company_id: companyId,
        page,
        perPage,
        search,
      },
    });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const createLocation = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/location/create",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateLocation = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/location/update",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteLocation = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/location/delete",
      payload
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
